import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_TRIALGROUPITEM_LOAD_BY_TRIALGROUP_ID,
    ACTION_TRIALGROUPITEM_LOAD_FAILURE,
    ACTION_TRIALGROUPITEM_LOAD_SUCCESS,

    ACTION_TRIALGROUPITEM_SAVE,
    ACTION_TRIALGROUPITEM_SAVE_SUCCESS,
    ACTION_TRIALGROUPITEM_SAVE_FAILURE,

    ACTION_TRIALGROUPITEM_CLEAR,
    TrialGroupItemAction,
    ACTION_TRIALGROUPITEM_CREATE,
    ACTION_TRIALGROUPITEM_CREATE_SUCCESS,
    ACTION_TRIALGROUPITEM_CREATE_FAILURE,
    ACTION_TRIALGROUPITEM_LOAD_BY_ID
} from '../actions/trialGroupItem';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from 'src/helpers/formErrorHelper';

export interface ITrialGroupItemState {
    formData: Dtos.TrialGroupItem | Dtos.TrialGroupItem[];
    groupedData: Dtos.TrialGroupItemCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    loadState: IRequestState;
    saveState: IRequestState;
    createState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.TrialGroupItem[];
    groupedFilteredData: Dtos.TrialGroupItemCategory[];
    lookups: Dtos.Lookup[],
    validationFailures: Dtos.ResponseError[];
}

const initialState: ITrialGroupItemState = {
    formData: undefined,
    groupedData: undefined,
    formState: undefined,
    formProperties: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    groupedFilteredData: [],
    lookups: undefined,
    validationFailures: undefined,
};


function loading(state: ITrialGroupItemState, _isLoading: boolean): ITrialGroupItemState {
    const newState: ITrialGroupItemState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: ITrialGroupItemState,
    formData: Dtos.TrialGroupItem | Dtos.TrialGroupItem[],
    groupedData: Dtos.TrialGroupItemCategory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialGroupItemState {
    const newState: ITrialGroupItemState = update(state, {
        formData: {
            $set: formData
        },
        groupedData: {
            $set: groupedData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: ITrialGroupItemState, formFilter: IFormFilter): ITrialGroupItemState {

    const data: Dtos.TrialGroupItem[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formFilteredData = data ? data.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || (p.search && p.search.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1))) : undefined;

    const groupedFilteredData = state.groupedData ? state.groupedData : [];

    const newState: ITrialGroupItemState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        groupedFilteredData: {
            $set: groupedFilteredData
        }
    });

    return newState;
}

function loadFailure(state: ITrialGroupItemState, responseStatus: Dtos.ResponseStatus): ITrialGroupItemState {
    const newState: ITrialGroupItemState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function saving(state: ITrialGroupItemState, _isSaving: boolean): ITrialGroupItemState {
    const newState: ITrialGroupItemState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ITrialGroupItemState,
    formData: Dtos.TrialGroupItem | Dtos.TrialGroupItem[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialGroupItemState {
    const newState: ITrialGroupItemState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ITrialGroupItemState, responseStatus: Dtos.ResponseStatus): ITrialGroupItemState {
    const newState: ITrialGroupItemState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: ITrialGroupItemState, _isCreating: boolean): ITrialGroupItemState {
    const newState: ITrialGroupItemState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ITrialGroupItemState,
    formData: Dtos.TrialGroupItem,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): ITrialGroupItemState {
    const newState: ITrialGroupItemState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ITrialGroupItemState, responseStatus: Dtos.ResponseStatus): ITrialGroupItemState {
    const newState: ITrialGroupItemState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: ITrialGroupItemState, propertiesToClear?: string[]): ITrialGroupItemState {

    if (!propertiesToClear) {
        const newState: ITrialGroupItemState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

const TrialGroupItemReducer: Reducer<ITrialGroupItemState> = (state: ITrialGroupItemState = initialState, action: TrialGroupItemAction) => {
    switch (action.type) {
        case ACTION_TRIALGROUPITEM_LOAD_BY_ID:
        case ACTION_TRIALGROUPITEM_LOAD_BY_TRIALGROUP_ID:
            return loading(state, true);
        case ACTION_TRIALGROUPITEM_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.groupedData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALGROUPITEM_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALGROUPITEM_SAVE:
            return saving(state, true);
        case ACTION_TRIALGROUPITEM_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALGROUPITEM_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_TRIALGROUPITEM_CREATE:
            return creating(state, true);
        case ACTION_TRIALGROUPITEM_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_TRIALGROUPITEM_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_TRIALGROUPITEM_CLEAR:
            return clear(state, action.propertiesToClear);
    }

    return state;
}

export default TrialGroupItemReducer;